const phoneValidator = (val) => {
  return /^[1-9][0-9]{7}$/.test(val)
}
const cyrillicValidator = (val) => {
  return /^([ӨөҮүЁёА-я]([- ])?)+$/.test(val)
}
const nameRegexValidator = (val) => {
  return /^([ӨөҮүЁёА-я\d]([- ])?)+$/.test(val)
}

export { phoneValidator, cyrillicValidator, nameRegexValidator }